<template>
	<div>
		<homeSearchVue :title="loja && loja.tituloPost ? loja.tituloPost : 'Carregando...'"
			:subtitle="loja && loja.descricaoPost ? loja.descricaoPost : 'Carregando...'"
			:nomeLoja="loja && loja.nomeLoja ? loja.nomeLoja : 'Carregando...'"
			:idLoja="loja && loja.idLoja ? loja.idLoja : 'Carregando...'"
			:idLojaLocacao="loja && loja.idLojaLocacao ? loja.idLojaLocacao : 'Carregando...'"
			:urlFotoCapa="loja && loja.fotoCapa ? loja.fotoCapa : 'https://old.apolar.com.br/wp-content/themes/homepress-apolar/assets/images/page-franquias-v2/header-banner-bg.webp'"
			:tipoNegocio="loja && loja.tipoNegocio ? loja.tipoNegocio : 3" :slug="slug" />

		<div class="rent" v-if="propriedadesVenda.length > 0">
			<div class="franquias-container">
				<SectionTitle :title="loja && loja.subTitleVen ? loja.subTitleVen : 'Carregando...'"
					:subtitle="'Confira os imóveis mais recentes à venda na região'" buttonLink="#" />

				<div class="fair-content">

					<div class="rent-content">
						<carousel ref="carousel" :items="1" :nav="false" :dots="true" :margin="16"
							:responsive="{ 0: { items: 1 }, 600: { items: 1 }, 1000: { items: 1 } }">
							<div v-for="(page, pageIndex) in pages" :key="pageIndex" class="rent-carousel-page">
								<div class="rent-carousel-grid">
									<PropertyCard v-for="(member, index) in page" :key="index"
										:idLoja="loja && loja.idLoja ? Number(filtro.idLoja) : 1" :property="{
											id: pageIndex * 8 + index,
											completeProperty: member,
											image: member.foto_principal,
											type: member.tipo,
											price: member.valorvenda,
											address: member.endereco,
											district: member.bairro,
											city: member.cidade,
											size: member.area_total,
											bedrooms: member.dormitorios,
											bathrooms: member.banheiro,
											garage: member.garagem,
											condominium: member.vlrconfominio > 0,
											pet: true,
										}" />
								</div>
							</div>
						</carousel>

						<div class="rent-pagination d-none">
							<button class="active">1</button>
							<button>2</button>
							<button>3</button>
							<button>...</button>
							<button>4</button>
							<button>
								<svg width="24" height="25" viewBox="0 0 24 25" fill="none"
									xmlns="http://www.w3.org/2000/svg">
									<mask id="mask0_11436_7900" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0"
										y="0" width="24" height="25">
										<rect y="0.272705" width="24" height="24" fill="#D9D9D9" />
									</mask>
									<g mask="url(#mask0_11436_7900)">
										<path
											d="M13.0307 12.2727L9.95575 15.3477L11 16.417L15.1443 12.2727L11 8.12845L9.95575 9.19771L13.0307 12.2727ZM12.0017 21.7727C10.6877 21.7727 9.45267 21.5234 8.2965 21.0247C7.14033 20.526 6.13467 19.8493 5.2795 18.9945C4.42433 18.1396 3.74725 17.1344 3.24825 15.9787C2.74942 14.823 2.5 13.5883 2.5 12.2745C2.5 10.9605 2.74933 9.72537 3.248 8.5692C3.74667 7.41304 4.42342 6.40737 5.27825 5.5522C6.13308 4.69704 7.13833 4.01995 8.294 3.52095C9.44967 3.02212 10.6844 2.77271 11.9983 2.77271C13.3123 2.77271 14.5473 3.02204 15.7035 3.5207C16.8597 4.01937 17.8653 4.69612 18.7205 5.55096C19.5757 6.40579 20.2528 7.41104 20.7518 8.56671C21.2506 9.72237 21.5 10.9571 21.5 12.271C21.5 13.585 21.2507 14.82 20.752 15.9762C20.2533 17.1324 19.5766 18.138 18.7218 18.9932C17.8669 19.8484 16.8617 20.5255 15.706 21.0245C14.5503 21.5233 13.3156 21.7727 12.0017 21.7727ZM12 20.2727C14.2333 20.2727 16.125 19.4977 17.675 17.9477C19.225 16.3977 20 14.506 20 12.2727C20 10.0394 19.225 8.14771 17.675 6.59771C16.125 5.04771 14.2333 4.27271 12 4.27271C9.76667 4.27271 7.875 5.04771 6.325 6.59771C4.775 8.14771 4 10.0394 4 12.2727C4 14.506 4.775 16.3977 6.325 17.9477C7.875 19.4977 9.76667 20.2727 12 20.2727Z"
											fill="#4552A0" />
									</g>
								</svg>
							</button>
						</div>
					</div>
				</div>

				<div class="rent-button-wrapper">
					<a :href="dynamicUrlForCity('venda')" class="rent-button">Ver todos</a>
				</div>
			</div>
		</div>

		<div class="fair" v-if="propriedadesLocacao.length > 0">
			<div class="franquias-container">
				<SectionTitle :title="loja && loja.subTitleLoc ? loja.subTitleLoc : 'Carregando...'"
					subtitle="Confira as novidades em imóveis para alugar na região" buttonLabel="Ver todos"
					buttonLink="/alugar?mensal" hasArrow="true" :hideButton="isMobile" />

				<template>
					<div class="fair-content">
						<carousel ref="carousel" :items="1" :nav="false" :dots="true" :margin="16"
							:responsive="{ 0: { items: 1 }, 600: { items: 1 }, 1000: { items: 1 } }">
							<div v-for="(page, pageIndex) in pagesLoc" :key="pageIndex" class="rent-carousel-page">
								<div class="rent-carousel-grid">
									<PropertyCard v-for="(member, index) in page" :key="index"
										:idLoja="loja && loja.idLoja ? Number(filtro.idLoja) : 1" :property="{
											id: pageIndex * 8 + index,
											completeProperty: member,
											image: member.foto_principal,
											type: member.tipo,
											price: member.valoraluguel,
											address: member.endereco,
											district: member.bairro,
											city: member.cidade,
											size: member.area_total,
											bedrooms: member.dormitorios,
											bathrooms: member.banheiro,
											garage: member.garagem,
											condominium: member.vlrconfominio > 0,
											pet: true,
										}" />
								</div>
							</div>
						</carousel>
					</div>
				</template>
				<div class="rent-button-wrapper">
					<a :href="dynamicUrlForCity('alugar')" class="rent-button">Ver todos</a>
				</div>
			</div>
		</div>

		<section class="info d-none">
			<div class="bairro-info-header">
				<div class="franquias-container">
					<div class="bairro-info-header-inner">
						<SectionTitle :title="loja && loja.subTitleExplore ? loja.subTitleExplore : 'Carregando...'"
							subtitle="Tudo o que você precisa saber sobre sua nova vizinhança" />
						<div class="bairro-info-tabs">
							<button class="tab active">
								<img src="@/assets/img/franquias/price_page.png" alt="" class="tab-icon" />
								Custo e Valores
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/directions_bus.png" alt="" class="tab-icon" />
								Transporte
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/school.png" alt="" class="tab-icon" />
								Educação
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/dictionary.png" alt="" class="tab-icon" />
								História
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/beenhere.png" alt="" class="tab-icon" />
								Segurança
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/domain.png" alt="" class="tab-icon" />
								Condomínios
							</button>
							<button class="tab">
								<img src="@/assets/img/franquias/local_convenience_store.png" alt="" class="tab-icon" />
								Comércio
							</button>
							<button class="tab next-icon">
								<img src="@/assets/img/franquias/arrow_forward_ios.png" alt="Próximo"
									class="tab-next-arrow" />
							</button>
						</div>
					</div>
				</div>
			</div>
			<div class="franquias-container">

				<div class="bairro-info-content">
					<div class="bairro-info-box">
						<h6 class="bairro-info-label">
							<img src="@/assets/img/franquias/request_page.png" alt=""
								style="width:40px;vertical-align:middle;margin-right:6px;">
							Custos e Valores
						</h6>
						<h3 class="bairro-info-title">Quanto custa morar no Bairro Alto?</h3>
						<p class="bairro-info-text">
							Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
							labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco
							laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in
							voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat
							cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.
						</p>
					</div>

					<div class="bairro-info-highlight">
						<div class="highlight-box">
							<div class="highlight-value">
								<span class="highlight-price">R$ 2 mil</span>
								<span class="highlight-label">Valor médio de aluguel</span>
							</div>
							<div class="highlight-info">
								<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
									incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
								<a href="#">
									Apartamentos para alugar no Bairro Alto
									<span class="highlight-arrow">
										<svg width="16" height="17" viewBox="0 0 16 17" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<mask id="mask0_2040_5475" style="mask-type:alpha"
												maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
												<rect y="0.544922" width="16" height="16" fill="#D9D9D9" />
											</mask>
											<g mask="url(#mask0_2040_5475)">
												<path
													d="M11.0847 9.04492H3V8.04492H11.0847L7.28717 4.24742L8 3.54492L13 8.54492L8 13.5449L7.28717 12.8424L11.0847 9.04492Z"
													fill="white" />
											</g>
										</svg>
									</span>
								</a>
							</div>
						</div>
						<div class="highlight-box">
							<div class="highlight-value">
								<span class="highlight-price">R$ 340 mil</span>
								<span class="highlight-label">Valor médio de imóvel<br> de entrada</span>
							</div>
							<div class="highlight-info">
								<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
									incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
								<a href="#">
									Imóveis de entrada a venda no Bairro Alto
									<span class="highlight-arrow">
										<svg width="16" height="17" viewBox="0 0 16 17" fill="none"
											xmlns="http://www.w3.org/2000/svg">
											<mask id="mask0_2040_5475" style="mask-type:alpha"
												maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
												<rect y="0.544922" width="16" height="16" fill="#D9D9D9" />
											</mask>
											<g mask="url(#mask0_2040_5475)">
												<path
													d="M11.0847 9.04492H3V8.04492H11.0847L7.28717 4.24742L8 3.54492L13 8.54492L8 13.5449L7.28717 12.8424L11.0847 9.04492Z"
													fill="white" />
											</g>
										</svg>
									</span>
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="lead">
			<div class="franquias-container">
				<SectionTitle title="Só a Apolar Imóveis oferece a<br/> experiência que você precisa" />
				<div class="lead-section-flex">
					<div class="lead-form-card">
						<h3>Procurando um imóvel?</h3>
						<p>Ainda não encontrou o imóvel ideal?<br>Deixe seu email e nossa equipe entrará em contato.</p>
						<div class="lead-form-toggle">
							<!-- lpfranquias orihem_id=57 -->
							<button type="button" :class="{ active: option === 'comprar' }" @click="option = 'comprar'"
								v-if="loja && loja.tipoNegocio != 2">
								Quero comprar
							</button>

							<button type="button" :class="{ active: option === 'alugar' }" @click="option = 'alugar'"
								v-if="loja && loja.tipoNegocio != 1">
								Quero alugar
							</button>
						</div>
						<form class="lead-form" @submit.prevent="handleSubmit">
							<div class="lead-form-fields">
								<div class="lead-form-row">
									<label>Qual seu nome?</label>
									<input type="text" placeholder="Nome e sobrenome" v-model="form.nome" required />
								</div>

								<div class="lead-form-row">
									<label>Tipo de imóvel desejado</label>
									<select v-model="form.tipoImovel" required>
										<option disabled value="">Selecione</option>
										<option value="Apartamento">Apartamento</option>
										<option value="Casa">Casa e sobrado</option>
										<option value="Comercial">Comercial</option>
										<option value="Terreno">Terreno</option>
									</select>
								</div>

								<div class="lead-form-row">
									<label>Email</label>
									<input type="email" placeholder="Digite email de contato" v-model="form.email"
										required />
								</div>

								<div class="lead-form-row">
									<label>Telefone de contato</label>
									<input type="tel" placeholder="(41)9999-9999" v-model="form.telefone" required />
								</div>
							</div>

							<button type="submit" class="lead-form-submit">Enviar minhas preferências</button>
						</form>
					</div>
					<div class="lead-cards-col">
						<div class="lead-card lead-card-announcer">
							<div class="lead-card-img">
								<img src="@/assets/img/franquias/forsale.png" alt="Anunciar" />
							</div>
							<div class="lead-card-content">
								<h4>Para quem quer anunciar com <br>segurança</h4>
								<p>A Apolar Imóveis tem mais de 60 anos de tradição e experiência no ramo imobiliário.
								</p>
								<button class="lead-announcer-btn" @click="$bvModal.show('AdvertiseModal')">Quero
									anunciar meu
									imóvel</button>
							</div>
						</div>
						<div class="lead-card lead-card-indicate">
							<div class="lead-card-img">
								<img src="@/assets/img/franquias/greenpig.png" alt="Indique" />
							</div>
							<div class="lead-card-content">
								<h4>Indique um imóvel e ganhe R$150</h4>
								<p>Compartilhe seu link com o proprietário ou cadastre o contato. Assim <br>que o imóvel
									for publicado você ganha!</p>
								<a href="/indique" target="_blank" class="lead-indicate-btn">Indicar imóvel</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="about">
			<div class="franquias-container">
				<div class="about-content-main-wrapper">
					<div class="about-content-bloc">
						<SectionTitle
							:title="loja && loja.subTitleConheca ? 'Conheça mais sobre a ' + loja.subTitleConheca : 'Carregando...'"
							subtitle="Sobre nossa franquia e nossa equipe" />
						<div class="bloc-for-mobile-image">
							<img :src="loja && loja.fotoFachada ? loja.fotoFachada : require('@/assets/img/franquias/fachada-apolar.png')"
								alt="">
						</div>
						<div class="about-content">
							<p class="about-content-main-text">{{ loja && loja.textoLoja ? loja.textoLoja :
								'Carregando...' }}</p>
							<div class="about-content-testimony">
								<img class="about-content-testimony-photo"
									:src="loja && loja.fotoFranqueado ? loja.fotoFranqueado : require('@/assets/img/franquias/team-dude-1.jpg')" />
								<div class="about-content-testimony-content">
									<img class="d-none" :src="require('@/assets/img/franquias/daniel-signature.png')" />
									<h5>{{ loja && loja.nomeFranqueado ? loja.nomeFranqueado.split(' ')[0] :
										'Carregando...' }}
									</h5>
									<h6>{{ loja && loja.nomeFranqueado ? loja.nomeFranqueado : 'Carregando...' }}</h6>
									<small>Franqueado Apolar</small>
								</div>
							</div>
						</div>
					</div>
					<div class="about-media-bloc">
						<img :src="loja && loja.fotoFachada ? loja.fotoFachada : require('@/assets/img/franquias/fachada-apolar.png')"
							alt="">
					</div>
				</div>
				<div class="about-team-main-wrapper" v-if="loja && loja.corretorLoja && loja.corretorLoja.length > 0">
					<SectionTitle :subtitle="`Equipe Apolar ${loja.nomeLoja}`" />
					<div class="about-team-carrousel-wrapper">
						<carousel :nav="true" :dots="!isMobile" :loop="loja.corretorLoja.length > 1" :margin="24"
							:responsive="{ 0: { items: 1 }, 768: { items: 2 }, 1000: { items: 3 }, 1300: { items: 4 } }"
							:navText="['<span class=&quot;custom-prev&quot;>‹</span>', '<span class=&quot;custom-next&quot;>›</span>']">
							<div class="item" v-for="(member, index) in loja.corretorLoja" :key="index">
								<div class="about-team-carrousel-item-card">
									<div class="about-team-carrousel-item-image">
										<img src="@/assets/img/franquias/team-dude-1.jpg">
									</div>
									<div class="about-team-carrousel-item-content">
										<h6>{{ member.nome }}</h6>
										<small>Corretor Apolar</small>
									</div>
								</div>
							</div>
						</carousel>
					</div>
				</div>
			</div>
		</section>

		<section class="reviews d-none">
			<div class="franquias-container">
				<SectionTitle title="O que as pessoas falam da Apolar Bairro Alto" buttonLabel="Deixar uma avaliação"
					buttonLink="#" hasArrow="true" />

				<div class="reviews-content">
					<img src="@/assets/img/franquias/google-reviews.png" alt="">

					<div class="reviews-content-card">
						<div class="reviews-content-card-stars">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
						</div>
						<p>Exceptional service! The team exceeded our expectations and delivered a top-notch product on
							time.</p>
						<div class="reviews-content-card-profile">
							<img src="@/assets/img/franquias/john-profile.png" alt="">
							<p>John Smith</p>
							<small>CEO, Tech Innovations Inc.</small>
						</div>
						<div class="reviews-content-card-info">
							<small>Posted on March 1, 2024</small>
							<img src="@/assets/img/franquias/google-logo-small.png" alt="">
						</div>
					</div>
					<div class="reviews-content-card">
						<div class="reviews-content-card-stars">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
						</div>
						<p>Working with this company was a game-changer. Their attention to detail are unmatched!</p>
						<div class="reviews-content-card-profile">
							<img src="@/assets/img/franquias/sarah-profile.png" alt="">
							<p>Sarah Johnson</p>
							<small>Marketing Manager, Bright Solutions</small>
						</div>
						<div class="reviews-content-card-info">
							<small>Posted on February 15, 2024</small>
							<img src="@/assets/img/franquias/google-logo-small.png" alt="">
						</div>
					</div>
					<div class="reviews-content-card">
						<div class="reviews-content-card-stars">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
							<img src="@/assets/img/franquias/star.png" alt="">
						</div>
						<p>A fantastic experience from start to finish. Highly recommended for anyone looking for
							quality
							wo...</p>
						<div class="reviews-content-card-profile">
							<img src="@/assets/img/franquias/michael-profile.png" alt="">
							<p>Michael Brown</p>
							<small>Founder, Brown & Co.</small>
						</div>
						<div class="reviews-content-card-info">
							<small>Posted on January 10, 2024</small>
							<img src="@/assets/img/franquias/google-logo-small.png" alt="">
						</div>
					</div>
				</div>
			</div>
		</section>

		<section class="socials-grid d-none">
			<div class="franquias-container">
				<SectionTitle title="Fique por dentro das novidades"
					subtitle="Siga nossas redes sociais e receba novidades em primeira mão" />
				<div class="socials-grid-wrapper">
					<div class="box1 follow-bloc">
						<img src="@/assets/img/franquias/socials-icon.png" alt="">
						<h6>@apolarimoveisbairroalto</h6>
						<button class="follow-button">Follow</button>
					</div>
					<div class="box2 post-bloc-item">
						<img src="@/assets/img/franquias/socials-2.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box3 post-bloc-item">
						<img src="@/assets/img/franquias/socials-3.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box4 post-bloc-item">
						<img src="@/assets/img/franquias/socials-4.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box5 post-bloc-item">
						<img src="@/assets/img/franquias/socials-5.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box6 post-bloc-item">
						<img src="@/assets/img/franquias/socials-6.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box7 post-bloc-item">
						<img src="@/assets/img/franquias/socials-7.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box8 post-bloc-item">
						<img src="@/assets/img/franquias/socials-8.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box9 post-bloc-item">
						<img src="@/assets/img/franquias/socials-9.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
					<div class="box10 post-bloc-item">
						<img src="@/assets/img/franquias/socials-10.png" alt="">
						<SocialsPostNumbers likes="18" coments="2" />
					</div>
				</div>
			</div>
		</section>

		<section class="see-also d-none">
			<div class="franquias-container">
				<SectionTitle title="Explore mais do mundo Apolar"
					subtitle="Confira nosso blog e mais das vantagens Apolar" buttonLabel="Ver blog Apolar"
					buttonLink="#" hasArrow="true" />
				<div class="see-also-posts">
					<PostCardSimple v-for="post in posts" :key="post.id" :post="post" />
				</div>
			</div>
		</section>

		<section class="newsletter">
			<div class="container">
				<div class="newsletter-content">
					<h2>Receba nossos posts diretamente no seu e-mail e fique por dentro das novidades</h2>
					<form>
						<span>Receba nossa newsletter</span>
						<div class="d-flex">
							<input type="email" id="email" name="email" v-model="emailCadastro"
								placeholder="Apolino@apolar.com.br" />
							<button class="desktop-button" @click="sendNewsletter()" type="button">Cadastrar</button>
						</div>
						<small>
							Ao se cadastrar, você concorda em receber nossos conteúdos. Saiba mais em nossa
							<RouterLink to="#">Política de Privacidade</RouterLink>.
						</small>
						<div class="mobile-button-wrapper">
							<button @click="sendNewsletter()" type="button">Cadastrar</button>
						</div>
					</form>
				</div>
			</div>
		</section>
		<AdvertiseModal />

		<div v-if="this.loja" class="whatsapp-float">
			<div class="spinner"></div>
			<a :href="`https://wa.me/55${loja.whatsappLoja.replace(/\D/g, '')}?text=Ol%C3%A1,%20gostaria%20de%20receber%20contato%20de%20um%20especialista!`"
				class="whatsapp-button" target="_blank" v-if="this.loja">
				<img src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg" alt="WhatsApp">
			</a>
		</div>

	</div>
</template>
<script>

import "@/assets/scss/custom/franquias/_home.scss"

import Vue from "vue";
import axios from 'axios';
import router from "@/router";
import Immobile from "../components/apolar/immobile";
import carousel from 'vue-owl-carousel'
import FormLancamentos from "../components/apolar/form-lancamentos.vue";
import homeSearchVue from '../components/apolar/franquias/home-search.vue';
import bannerHomeActionVue from '../components/apolar/lancamentos/banner-home-action.vue';
import bannerHomeInvistaActionVue from '../components/apolar/lancamentos/banner-home-invista-action.vue';
import PropertiesCarousel from "../components/apolar/principal/properties-carousel.vue"
import PropertiesService from "../../services/PropertiesService";
import SectionTitle from "../components/apolar/franquias/section-title.vue";
import PostCardSimple from "../components/apolar/franquias/post-card-simples.vue";
import PropertyCard from "../components/apolar/franquias/property-card.vue";
import FairPropertyCard from "../components/apolar/franquias/fair-property-card.vue";
import SocialsPostNumbers from "../components/apolar/franquias/SocialsPostNumbers.vue";
import AdvertiseModal from '../components/apolar/triplea/modals/advertise-modal.vue'

export default {
	name: "franquias",
	components: {
		carousel,
		Immobile,
		FormLancamentos,
		homeSearchVue,
		bannerHomeActionVue,
		bannerHomeInvistaActionVue,
		PropertiesCarousel,
		SectionTitle,
		PostCardSimple,
		PropertyCard,
		FairPropertyCard,
		SocialsPostNumbers,
		AdvertiseModal
	},
	metaInfo() {
		return {
			title: "Franquias",
			meta: [
				{
					vmid: "description",
					name: "description",
					content: "Apolar Franquias"
				}
			]
		};
	},
	data() {
		return {
			slug: this.$route.params['slug'],
			emailCadastro: '',
			form: {
				nome: '',
				tipoImovel: '',
				email: '',
				telefone: ''
			},
			option: 'comprar',
			filtro: {
				idLoja: null,
				size: 16,
				country: 'Brasil',
				business: '',
				city: null,
				district: [],
				showStoreImmobiles: false
			},
			loja: null,
			propriedadesVenda: [],
			propriedadesLocacao: [],
			currentRentPage: 1,
			totalRentPages: 4,
			locality_selected: "todas",
			localities_options: [
				{ value: "todas", label: "Todas as Cidades" },
				{ value: "curitiba", label: "Curitiba" },
				{ value: "grande-curitiba", label: "Grande Curitiba" },
				{ value: "litoral", label: "Litoral" },
				{ value: "parana-santa-catarina", label: "Paraná/Santa Catarina" }
			],
			properties: [],
			totalPages: 3,
			propertiesPerPage: 4,
			posts: [
				{
					id: 1,
					image: require('@/assets/img/franquias/post-1.png'),
					title: 'Imóveis valorizam 20% nos bairros Tarumã e Bairro Alto',
					slug: 'imoveis-valorizam-nos-bairros-taruma-e-bairro-alto',
					category: 'Investimento',
					author: 'Lucas Bertolazo',
				},
				{
					id: 2,
					image: require('@/assets/img/franquias/post-2.png'),
					title: 'Imóveis valorizam 20% nos bairros Tarumã e Bairro Alto',
					slug: 'imoveis-valorizam-nos-bairros-taruma-e-bairro-alt',
					category: 'Investimento',
					author: 'Lucas Bertolazo',
				},
				{
					id: 3,
					image: require('@/assets/img/franquias/post-3.png'),
					title: 'Imóveis valorizam 20% nos bairros Tarumã e Bairro Alto',
					slug: 'imoveis-valorizam-nos-bairros-taruma-e-bairro-al',
					category: 'Investimento',
					author: 'Lucas Bertolazo',
				},
				{
					id: 4,
					image: require('@/assets/img/franquias/post-4.png'),
					title: 'Imóveis valorizam 20% nos bairros Tarumã e Bairro Alto',
					slug: 'imoveis-valorizam-nos-bairros-taruma-e-bairro-a',
					category: 'Investimento',
					author: 'Lucas Bertolazo',
				}
			],
			scroll_id: '',
			total: 0,
			form_lancamentos: {
				open: false,
				immobile_name: ''
			},
			layout_top_slider: [
				{ "slides": ['alphaville', 'lemonde', 'reserva'], 'weeks': [37, 38, 41, 44, 47, 50, 53, 56] },
				{ "slides": ['lemonde', 'reserva', 'alphaville'], 'weeks': [39, 42, 45, 48, 51, 54, 57] },
				{ "slides": ['reserva', 'alphaville', 'lemonde'], 'weeks': [40, 43, 46, 49, 52, 55, 58] }
			]
		};
	},
	computed: {

		getLayoutSlide() {
			let weekNumber = new Date().getWeekNumber()
			let slides = this.layout_top_slider[0]['slides']

			this.layout_top_slider.forEach((slideTemplate) => {
				if (slideTemplate['weeks'].indexOf(weekNumber) != -1) {
					slides = slideTemplate['slides']
				}
			})

			return slides
		},

		locality_selected_label: function () {
			let list = this.localities_options.filter(
				(opt) => opt.value == this.locality_selected
			);
			return list.length > 0 ? list[0].label : "";
		},
		pages() {
			const isMobile = window.innerWidth <= 600
			const chunkSize = isMobile ? 1 : 8
			const result = []
			const maxSlidesMobile = 6
			for (let i = 0; i < this.propriedadesVenda.length; i += chunkSize) {
				result.push(this.propriedadesVenda.slice(i, i + chunkSize))
			}
			return isMobile ? result.slice(0, maxSlidesMobile) : result
		},
		pagesLoc() {
			const isMobile = window.innerWidth <= 600
			const chunkSize = isMobile ? 1 : 8
			const result = []
			const maxSlidesMobile = 6
			for (let i = 0; i < this.propriedadesLocacao.length; i += chunkSize) {
				result.push(this.propriedadesLocacao.slice(i, i + chunkSize))
			}
			return isMobile ? result.slice(0, maxSlidesMobile) : result
		}
	},
	methods: {
		sendNewsletter() {
			axios.post(
				'https://old.apolar.com.br/wp-admin/admin-ajax.php?action=send_newsletterregister',
				{
					emailCadastro: this.emailCadastro,
					emailDestino: this.loja.emailLoja,
					assunto: 'Página de Franquias - Cadastro para recebimento de novidades',
				},
				{
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					},
					transformRequest: [(data) => {
						const params = new URLSearchParams()
						for (const key in data) {
							params.append(key, data[key])
						}
						return params
					}]
				}
			)
				.then(response => {
					alert('Cadastro realizado com sucesso! Você receberá novidades em breve.')
					this.emailCadastro = ''
				})
				.catch(error => {
					console.error('Erro:', error)
				})
		},
		showLoading() {
			const loader = this.$refs.loader
			loader.style.display = 'flex'
			loader.style.opacity = 0
			let op = 0
			const fadeIn = setInterval(() => {
				op += 0.1
				loader.style.opacity = op
				if (op >= 1) clearInterval(fadeIn)
			}, 50)
		},
		showSuccess() {
			const loader = this.$refs.loader
			loader.classList.add('success-icon')
			const spinner = loader.querySelector('.spinner')
			const icon = loader.querySelector('.success-icon')
			spinner.style.display = 'none'
			icon.style.display = 'flex'
			setTimeout(() => this.hideLoading(), 1800)
		},
		hideLoading() {
			const loader = this.$refs.loader
			loader.classList.remove('success-icon')
			const spinner = loader.querySelector('.spinner')
			const icon = loader.querySelector('.success-icon')
			let op = 1
			const fadeOut = setInterval(() => {
				op -= 0.1
				loader.style.opacity = op
				if (op <= 0) {
					clearInterval(fadeOut)
					loader.style.display = 'none'
					spinner.style.display = 'flex'
					icon.style.display = 'none'
				}
			}, 50)
		},
		handleSubmit() {
			// console.log('Form submitted:', this.form);
			let endpoint = 'https://sales2.ops.digital/version-test/api/1.1/wf/landing_pages';
			let token = '18b1c2ca0ccda1defcdfd6f963d309de';
			let negocio = this.option === 'comprar' ? '3' : '1';
			let stringLoja = this.loja.idLoja.toString();

			if (this.loja.tipoNegocio == 3) {
				if (this.option === 'comprar') {
					stringLoja = this.loja.idLoja.toString();
				}
				else {
					stringLoja = this.loja.idLojaLocacao.toString();
				}
			}

			if (stringLoja.length < 2) {
				stringLoja = '00' + stringLoja;
			}
			if (stringLoja.length < 3) {
				stringLoja = '0' + stringLoja;
			}

			const payload = {
				origem: '57',
				negocio: negocio,
				loja: stringLoja,
				tipo_imovel: this.form.tipoImovel,
				nome: this.form.nome,
				email: this.form.email,
				telefone: this.form.telefone,
			};

			axios.post(
				endpoint,
				payload,
				{
					headers: {
						Authorization: `Bearer ${token}`
					}
				}
			)
				.then(response => {

					// console.log('Resposta:', response)
					alert('Enviado com sucesso!')
					this.form = {
						nome: '',
						tipoImovel: '',
						email: '',
						telefone: ''
					}
				})
				.catch(error => {

					console.error('Erro ao enviar:', error)
					alert('Erro ao enviar o formulário.')
				})
		},
		dynamicUrlForCity(tipoNegocio) {
			const params = {
				transaction: tipoNegocio.toLowerCase()
			};
			let tipoNegocio2 = tipoNegocio === 'venda' ? 1 : 2;
			if (this.loja) {
				params["city"] = this.slugify(this.loja.cidadeLoja);
				if (this.loja.bairroLoja)
					params["district"] = this.slugify(this.loja.bairroLoja);
			}
			const routeData = router.resolve({
				name: "principal-property-search",
				params,
			});

			if (!this.loja)
				return `${routeData.href}?country=Brasil`;
			else
				return `${routeData.href}?country=Brasil&idLoja=${this.loja.idLoja}&showStoreImmobiles=false`;
		},
		slugify(text) {
			return text
				.normalize("NFD")                  // separa os acentos
				.replace(/[\u0300-\u036f]/g, "")   // remove os acentos
				.toLowerCase()                     // tudo minúsculo
				.replace(/\s+/g, "-");             // troca espaço por traço
		},
		searchFranquia() {
			const token = 'aWYqfD78gKLtXzRMp5NCEU3voJx9BGuFQysnZBrOdLTb0mVlHXi24ehYwkcOAjPLgQBnvMuRfSdXK63tjaWab5==';
			var slug = this.$route.params['slug']
			// console.log('slug', slug)
			axios.get('https://homologwssite.apolar.net/api/v1/WSPaginaLojas', {
				params: {
					slug: this.$route.params['slug'] || 'novomundo'
				},
				headers: {
					Authorization: `Bearer ${token}`
				}
			}).then(response => {

				if (!response.data.sucesso)
					this.$router.push('/franquias');

				this.loja = response.data.conteudo;

				this.filtro.idLoja = this.loja.idLoja
				this.filtro.size = 24
				this.filtro.country = 'Brasil'
				this.filtro.business = 'Vendas'
				this.filtro.useCurrentNeighborhood = true
				this.filtro.city = this.loja.cidadeLoja
				if (this.loja.bairroLoja)
					this.filtro.district.push(this.loja.bairroLoja)

				if (this.loja.tipoNegocio == 2)
					this.option = 'alugar'
				else
					this.option = 'comprar'

				// console.log(this.loja, 'lojaaa');

				// Adiciona Google Analytics se existir ID
				if (this.loja.googleAnaliticsId && this.loja.googleAnaliticsId.length > 0) {
					const gaId = this.loja.googleAnaliticsId;

					const gaScript = document.createElement('script');
					gaScript.setAttribute('async', '');
					gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
					document.head.appendChild(gaScript);

					const gtagScript = document.createElement('script');
					gtagScript.innerHTML = `
											window.dataLayer = window.dataLayer || [];
											function gtag(){dataLayer.push(arguments);}
											gtag('js', new Date());
											gtag('config', '${gaId}');
										`;
					document.head.appendChild(gtagScript);

					// console.log('Google Analytics ID Inserido:', gaId);
				}


				// Adiciona Google Tag Manager se existir ID
				if (this.loja.gtmId && this.loja.gtmId.length > 0) {
					const gtmId = this.loja.gtmId;
					const gtmScript = document.createElement('script');
					gtmScript.innerHTML = `
											(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
											new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
											j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;
											j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
											f.parentNode.insertBefore(j,f);
											})(window,document,'script','dataLayer','${gtmId}');
										`;
					document.head.appendChild(gtmScript);

					const noscript = document.createElement('noscript');
					noscript.innerHTML = `
											<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}"
											height="0" width="0" style="display:none;visibility:hidden"></iframe>
										`;
					document.body.appendChild(noscript);
					// console.log('Google Tag Manager ID Inserido:', this.loja.gtmId);
				}
				PropertiesService.search(this.filtro, this.data_index)
					.then(
						response => {

							if (this.loja.tipoNegocio != 2)
								this.propriedadesVenda = response.data;

							if ((this.loja.idLojaLocacao != null && this.loja.tipoNegocio == 3) || this.loja.tipoNegocio == 2) {
								this.filtro.business = 'Locacao'
								this.filtro.useCurrentNeighborhood = true
								if (this.loja.tipoNegocio == 3)
									this.filtro.idLoja = this.loja.idLojaLocacao

								PropertiesService.search(this.filtro, this.data_index)
									.then(
										response2 => {
											this.propriedadesLocacao = response2.data;
											// console.log('Locação', this.propriedadesLocacao);
										}
									)
							}


						}
					)
			}).catch(error => {
				console.error('Erro na requisição:', error);
			});
		},
		openLocalityOptions: function () {
			if (
				document
					.querySelector(".locality_selected")
					.classList.contains("opened")
			) {
				document.querySelector(".locality_selected").classList.remove("opened");
				document.querySelector("ul.filter-localities-options").classList.remove("opened");
			} else {
				document.querySelector(".locality_selected").classList.add("opened");
				document.querySelector("ul.filter-localities-options").classList.add("opened");
			}
		},
		changeLocality: function (locality) {
			this.locality_selected = locality;
			document.querySelector(".locality_selected").classList.remove("opened");
			document.querySelector("ul.filter-localities-options").classList.remove("opened");

			let home_filter = locality != "todas" ? { "city": locality } : {}
			this.search(home_filter)
		},
		search(filters, append = false) {
			PropertiesService.customSearch(filters)
				.then(
					response => {
						var properties = response.data
						if (append) {
							properties = this.properties.concat(response.data)
						}
						Vue.set(this, "properties", properties)
						Vue.set(this, "scroll_id", response.scroll_id)
						Vue.set(this, 'total', response.total)
					}
				)
		},
		loadMore() {
			let next_page = { "scroll_id": this.scroll_id }
			this.search(next_page, true)
		},
		openFormLancamentos(immobile_name) {
			this.form_lancamentos.immobile_name = immobile_name
			this.form_lancamentos.open = true
		},
		goToRentPage(n) {
			this.currentRentPage = n;
			const carousel = this.$refs.rentCarousel;
			if (carousel && typeof carousel.to === 'function') {
				carousel.to(n - 1);
			} else if (carousel && typeof carousel.goTo === 'function') {
				carousel.goTo(n - 1);
			}
		}
	},
	mounted() {
		this.searchFranquia();

		this.search({})
		// PropertiesService.getFilters()
		// .then(
		//     response => {
		//         let localities_options = response.data.cities.map(item => {return {value:item.city, label:item.city}})
		//         localities_options.unshift({ value: "todas", label: "Todas as Cidades" })
		//         Vue.set(this, "localities_options", localities_options.slice(0, 5))
		//     }
		// )
	},
	watch: {
		loja: function (newValue) {
			if (newValue) {
				this.loja = newValue;
			}
		}
	}
};
</script>